const fmt = require('indian-number-format');
const {toBengaliWord} = require('bengali-number');

export default {
  valueParse(value){
    value = parseFloat(value)
    if(isNaN(value) || typeof value === 'string' || value instanceof String){
      return 0;
    }
    return parseFloat(value);
  },

  commaWithCurrency(value){
    const digits = { '0': '০', '1': '১', '2': '২', '3': '৩', '4': '৪', '5': '৫', '6': '৬', '7': '৭', '8': '৮', '9': '৯' };
    let text = "৳ "+fmt.format(this.valueParse(value))
    return text.replace(/[0-9]/g, d => digits[d]);
  },
  commaDecimalWithCurrency(value){
    const digits = { '0': '০', '1': '১', '2': '২', '3': '৩', '4': '৪', '5': '৫', '6': '৬', '7': '৭', '8': '৮', '9': '৯' };
    let text = "৳ "+fmt.formatFixed(this.valueParse(value),2)
    return text.replace(/[0-9]/g, d => digits[d]);

  },
  comma(value){
    const digits = { '0': '০', '1': '১', '2': '২', '3': '৩', '4': '৪', '5': '৫', '6': '৬', '7': '৭', '8': '৮', '9': '৯' };
    let text = fmt.format(this.valueParse(value))
    return text.replace(/[0-9]/g, d => digits[d]);

  },
  commaDecimal(value){
    const digits = { '0': '০', '1': '১', '2': '২', '3': '৩', '4': '৪', '5': '৫', '6': '৬', '7': '৭', '8': '৮', '9': '৯' };
    let text = fmt.formatFixed(this.valueParse(value),2)
    return text.replace(/[0-9]/g, d => digits[d]);

  },
  toWordPlain(value){
    return toBengaliWord(this.valueParse(value))
  },
  toWordCurrency(value){
    return toBengaliWord(this.valueParse(value))+" টাকা মাত্র";
  },
  toBanglaTextDate(value){
    const digits = { '0': '০', '1': '১', '2': '২', '3': '৩', '4': '৪', '5': '৫', '6': '৬', '7': '৭', '8': '৮', '9': '৯' };
    let date = value.split("-");
    let dd = date[0]
    let mm = parseInt(date[1])
    switch (mm) {
      case 1:
        mm = 'জানুয়ারি';
        break;
      case 2:
        mm = 'ফেব্রুয়ারি';
        break;
      case 3:
        mm = 'মার্চ';
        break;
      case 4:
        mm = 'এপ্রিল';
        break;
      case 5:
        mm = 'মে';
        break;
      case 6:
        mm = 'জুন';
        break;
      case 7:
        mm = 'জুলাই';
        break;
      case 8:
        mm = 'আগস্ট';
        break;
      case 9:
        mm = 'সেপ্টেম্বর';
        break;
      case 10:
        mm = 'অক্টোবর';
        break;
      case 11:
        mm = 'নভেম্বর';
        break;
      case 12:
        mm = 'ডিসেম্বর';
        break;
    }
    let yyyy = date[2]
    let text = dd+" "+mm+" "+yyyy
    return text.replace(/[0-9]/g, d => digits[d]);

  }

}
